import React,{Component} from 'react';
import $ from 'jquery';
import './DynamicAssets.scss'
import DynamicAsset from './DynamicAsset/DynamicAsset';
import data from './assetData';


class DynamicAssets extends Component{
constructor(props){
    super(props);
}
render(){
    const assetData =data;

    const dynamicAssets= assetData.map((assetData) => {
        if(assetData.roles.includes(this.props.role)){
        return(
            <DynamicAsset 
            title={assetData.title} 
            image={assetData.image}
            description={assetData.description} 
            ctaText={assetData.cta_text}
            ctaURL={assetData.url}
            />
        )
        }
    });
    return(
        <div>
    {dynamicAssets}
        </div>
    
    )
}

}




export default DynamicAssets